import { object, string } from 'yup';
export const Fields = [
  {
    name: 'email',
    placeholder: 'Email',
    label: 'Email',
  },
];
export const validationSchema = object({
  email: string().required('Required').email('Enter a valid email address!'),
});
export const initialValues = {
  email: '',
};
